import { AppConfig } from "../src/config/schemas.js";

/**
 * Bake in the production launch config here.
 * Prevents a majority of cases where the user
 * could override values.
 */
export const appConfig: AppConfig = {
  propelAuth: {
    url: "https://auth.onegrep.dev",
  },
  oidc: {
    discoveryUrl: "https://auth.onegrep.dev/.well-known/openid-configuration",
    clientId: "9de8c8c4fd9cf1c63a9c95d079979a09",
  },
  agent: {
    agentType: "blaxel",
    url: "https://run.blaxel.ai/onegrep/agents/agent-demo-sandbox",
    apiKey: "bl_216917beczu7cngzk2rrnuzx2vn766te",
  },
  demoSandbox: {
    api: {
      url: "https://demo.sandbox.onegrep.dev",
    },
    invitationCode: "SANDBOX",
  },
  posthog: {
    apiKey: "phc_76OFLcbYe3zQ6QUcIUKl2tMwUveGOBwNBfG6H9Ed4rK",
  },
};
